/* ============================================================
   BAMBERG MODEHAUS — Herbst 2026
   Groessenassistent · Warenkorb-Fortschritt · Akkordeon
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- Hilfen ---------------- */
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function debounce(fn, ms) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }

  /* ============================================================
     1) WARENKORB-FORTSCHRITT
     2 Artikel = 10%, 3 = 15%, 4 = 20%  (aktive Shopify-Automatikrabatte)
     ============================================================ */
  var TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }
  ];
  var MAXQ = TIERS[TIERS.length - 1].qty;

  function progressMarkup() {
    var steps = TIERS.map(function (t) {
      return '<span class="bmh-cartprogress__step" data-q="' + t.qty + '">' + t.qty + ' Artikel &minus;' + t.pct + '%</span>';
    }).join('');
    return '<div class="bmh-cartprogress" data-bmh-progress>' +
             '<p class="bmh-cartprogress__msg" data-bmh-progress-msg></p>' +
             '<div class="bmh-cartprogress__track"><span class="bmh-cartprogress__fill" data-bmh-progress-fill></span></div>' +
             '<div class="bmh-cartprogress__steps">' + steps + '</div>' +
           '</div>';
  }

  function renderProgress(count) {
    $$('[data-bmh-progress]').forEach(function (box) {
      var fill = $('[data-bmh-progress-fill]', box);
      var msg  = $('[data-bmh-progress-msg]', box);
      var pct  = Math.min(100, (count / MAXQ) * 100);
      if (fill) fill.style.width = pct + '%';

      var reached = null, next = null;
      TIERS.forEach(function (t) {
        if (count >= t.qty) reached = t;
        else if (!next) next = t;
      });

      if (msg) {
        if (!count) {
          msg.innerHTML = 'Ab <b>2 Artikeln</b> sparen Sie automatisch 10&nbsp;%.';
        } else if (next) {
          var miss = next.qty - count;
          msg.innerHTML = 'Noch <b>' + miss + ' Artikel</b> bis <b>&minus;' + next.pct + '&nbsp;%</b>' +
                          (reached ? ' &middot; aktuell &minus;' + reached.pct + '&nbsp;% gesichert' : '') + '.';
        } else {
          msg.innerHTML = 'Maximaler Rabatt erreicht: <b>&minus;' + reached.pct + '&nbsp;%</b> auf Ihre Bestellung.';
        }
      }
      $$('.bmh-cartprogress__step', box).forEach(function (s) {
        s.classList.toggle('is-done', count >= parseInt(s.getAttribute('data-q'), 10));
      });
    });
  }

  var refreshCart = debounce(function () {
    fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      credentials: 'same-origin', headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) renderProgress(c.item_count || 0); })
      .catch(function () {});
  }, 180);

  /* Fortschrittsbalken in die Warenkorb-Schublade einhaengen */
  function mountProgress() {
    var hosts = $$('[data-bmh-progress-host]');
    if (!hosts.length) {
      // Fallback: bekannte Container der Schublade
      ['#CartDrawer .drawer__inner', '#CartDrawer form', '.drawer--cart .drawer__inner'].some(function (sel) {
        var el = $(sel);
        if (el && !$('[data-bmh-progress]', el)) {
          el.insertAdjacentHTML('afterbegin', progressMarkup());
          return true;
        }
        return false;
      });
    } else {
      hosts.forEach(function (h) {
        if (!$('[data-bmh-progress]', h)) h.innerHTML = progressMarkup();
      });
    }
    refreshCart();
  }

  /* Warenkorb-Aenderungen erkennen (fetch + XHR) */
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var url = arguments[0];
      var p = _fetch.apply(this, arguments);
      try {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refreshCart, 60); });
      } catch (e) {}
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try { if (/\/cart\/(add|change|update|clear)/.test(u || '')) this.addEventListener('load', function () { setTimeout(refreshCart, 60); }); } catch (e) {}
    return _open.apply(this, arguments);
  };
  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('cart:build', refreshCart);

  /* ============================================================
     2) AKKORDEON
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bmh-acc__btn');
    if (!btn) return;
    var item = btn.closest('.bmh-acc__item');
    if (!item) return;
    var open = item.classList.contains('is-open');
    item.classList.toggle('is-open', !open);
    btn.setAttribute('aria-expanded', String(!open));
  });

  /* ============================================================
     3) GROESSENASSISTENT
     ============================================================ */
  var ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];

  function normSize(v) {
    var s = String(v).trim().toUpperCase().replace(/\s|-/g, '');
    if (s === 'XXL') return '2XL';
    if (s === 'XXXL') return '3XL';
    if (s === 'XXXXL') return '4XL';
    if (s === 'XXXXXL') return '5XL';
    return s;
  }

  /* Konfektionsgroesse aus Groesse + Gewicht.
     Rueckgabe: Index in ORDER (kann Nachkommastellen haben) */
  function baseIndex(gender, hCm, kg) {
    var W = gender === 'h'
      ? [62, 71, 81, 91, 102, 115, 129, 143]     // Herren: Grenzen XS|S|M|L|XL|2XL|3XL|4XL
      : [52, 59, 67, 76, 86, 98, 111, 126];      // Damen
    var i = 0;
    while (i < W.length && kg >= W[i]) i++;
    // i = 0 -> XS, 1 -> S ...
    var refH = gender === 'h' ? 180 : 168;
    var adj = (hCm - refH) / 18;                 // sehr gross/klein verschiebt leicht
    if (adj > 0.8) adj = 0.8;
    if (adj < -0.8) adj = -0.8;
    return i + adj;
  }

  function clampIdx(i) { return Math.max(0, Math.min(ORDER.length - 1, Math.round(i))); }

  /* verfuegbare Optionswerte aus dem DOM lesen */
  function availableSizes(root) {
    var vals = [];
    $$('[data-bmh-size-value]', root || document).forEach(function (el) {
      var v = el.getAttribute('data-bmh-size-value');
      if (v && vals.indexOf(v) === -1) vals.push(v);
    });
    return vals;
  }

  function pickClosest(target, list, numeric) {
    if (!list.length) return null;
    if (numeric) {
      var t = parseFloat(target);
      var best = null, bd = 1e9;
      list.forEach(function (v) {
        var n = parseFloat(String(v).replace(',', '.'));
        if (isNaN(n)) return;
        var d = Math.abs(n - t);
        if (d < bd) { bd = d; best = v; }
      });
      return best;
    }
    var idxWanted = ORDER.indexOf(target);
    var best2 = null, bd2 = 1e9;
    list.forEach(function (v) {
      var i = ORDER.indexOf(normSize(v));
      if (i === -1) return;
      var d = Math.abs(i - idxWanted);
      if (d < bd2) { bd2 = d; best2 = v; }
    });
    return best2;
  }

  var SA = {
    step: 0, data: {}, cfg: null, result: null,

    open: function (trigger) {
      var host = document.getElementById('bmhSizeAssistant');
      if (!host) return;
      this.cfg = {
        gender: host.getAttribute('data-gender') || 'd',
        kind: host.getAttribute('data-kind') || 'top',
        sizes: availableSizes(document)
      };
      this.step = 0; this.data = {}; this.result = null;
      host.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      this.render();
    },

    close: function () {
      var host = document.getElementById('bmhSizeAssistant');
      if (!host) return;
      host.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    },

    steps: function () {
      if (this.cfg.kind === 'shoe') return ['foot', 'fitShoe', 'result'];
      return ['body', 'build', 'fit', 'result'];
    },

    render: function () {
      var host = document.getElementById('bmhSizeAssistant');
      var body = $('[data-sa-body]', host);
      var foot = $('[data-sa-foot]', host);
      var steps = this.steps();
      var name = steps[this.step];
      var dots = steps.map(function (s, i) {
        return '<span class="bmh-sa__dot' + (i <= this.step ? ' is-active' : '') + '"></span>';
      }, this).join('');

      var html = '<div class="bmh-sa__steps">' + dots + '</div>';

      if (name === 'body') {
        html += '<p class="bmh-sa__q">Ihre Körpergröße und Ihr Gewicht</p>' +
          '<p class="bmh-sa__hint">Wir rechnen daraus Ihre Konfektionsgröße. Ihre Angaben werden nicht gespeichert.</p>' +
          '<div class="bmh-sa__field"><label for="saH">Körpergröße in cm</label>' +
          '<input class="bmh-sa__input" id="saH" type="number" inputmode="numeric" min="130" max="215" placeholder="z. B. 168" value="' + (this.data.h || '') + '"></div>' +
          '<div class="bmh-sa__field"><label for="saW">Gewicht in kg</label>' +
          '<input class="bmh-sa__input" id="saW" type="number" inputmode="numeric" min="35" max="200" placeholder="z. B. 68" value="' + (this.data.w || '') + '"></div>' +
          '<p class="bmh-sa__err bmh-hide" data-sa-err>Bitte tragen Sie Größe und Gewicht ein.</p>';
      }

      if (name === 'foot') {
        html += '<p class="bmh-sa__q">Ihre Fußlänge</p>' +
          '<p class="bmh-sa__hint">Stellen Sie sich mit der Ferse an eine Wand und messen Sie bis zur längsten Zehe. Messen Sie am besten abends.</p>' +
          '<div class="bmh-sa__field"><label for="saF">Fußlänge in cm</label>' +
          '<input class="bmh-sa__input" id="saF" type="number" inputmode="decimal" step="0.1" min="19" max="34" placeholder="z. B. 25,5" value="' + (this.data.f || '') + '"></div>' +
          '<p class="bmh-sa__err bmh-hide" data-sa-err>Bitte tragen Sie Ihre Fußlänge ein.</p>';
      }

      if (name === 'build') {
        html += '<p class="bmh-sa__q">Wie ist Ihre Statur?</p>' +
          '<p class="bmh-sa__hint">Das hilft uns bei Taille und Bundweite.</p>' + this.opts('build', [
            ['schlank', 'Eher schmal', 'Taille deutlich schmaler als Hüfte oder Brust'],
            ['normal', 'Ausgeglichen', 'Gleichmäßige Proportionen'],
            ['kraeftig', 'Kräftiger um die Mitte', 'Taille und Bauch etwas stärker']
          ]);
      }

      if (name === 'fit') {
        html += '<p class="bmh-sa__q">Wie mögen Sie den Sitz?</p>' +
          '<p class="bmh-sa__hint">' + (this.cfg.kind === 'outer'
            ? 'Bei Jacken und Mänteln zählt, was Sie darunter tragen.'
            : 'Manche mögen es figurbetont, andere lieber locker.') + '</p>' +
          this.opts('fit', this.cfg.kind === 'outer' ? [
            ['eng', 'Nur ein Shirt darunter', 'Schmal und körpernah'],
            ['normal', 'Normal', 'Platz für einen dünnen Pullover'],
            ['weit', 'Dicker Strick darunter', 'Bewusst weiter geschnitten']
          ] : [
            ['eng', 'Figurbetont', 'Liegt am Körper an'],
            ['normal', 'Normal', 'Klassischer Sitz'],
            ['weit', 'Locker und bequem', 'Etwas mehr Luft']
          ]);
      }

      if (name === 'fitShoe') {
        html += '<p class="bmh-sa__q">Wie ist Ihr Fuß?</p>' +
          '<p class="bmh-sa__hint">Bei breiten Füßen empfehlen wir eine halbe Nummer mehr.</p>' + this.opts('foot2', [
            ['schmal', 'Eher schmal', 'Schuhe sitzen oft locker'],
            ['normal', 'Normal', 'Standardweite passt meist'],
            ['breit', 'Eher breit', 'Schuhe drücken oft seitlich']
          ]);
      }

      if (name === 'result') html += this.resultHtml();

      body.innerHTML = html;

      /* Fusszeile */
      var isLast = name === 'result';
      var back = this.step > 0 ? '<button type="button" class="btn btn--secondary" data-sa-back>Zurück</button>' : '';
      if (isLast && this.result) {
        foot.innerHTML = back +
          '<button type="button" class="btn bmh-btn-copper" data-sa-add>Größe ' + this.result.label + ' in den Warenkorb</button>';
      } else if (isLast) {
        foot.innerHTML = back + '<button type="button" class="btn" data-sa-close>Schließen</button>';
      } else {
        foot.innerHTML = back + '<button type="button" class="btn" data-sa-next>Weiter</button>';
      }
    },

    opts: function (key, list) {
      var cur = this.data[key];
      return '<div class="bmh-sa__opts">' + list.map(function (o) {
        return '<label class="bmh-sa__opt">' +
          '<input type="radio" name="sa_' + key + '" value="' + o[0] + '"' + (cur === o[0] ? ' checked' : '') + '>' +
          '<span class="bmh-sa__radio"></span>' +
          '<span class="bmh-sa__optbody"><b>' + o[1] + '</b><span>' + o[2] + '</span></span>' +
          '</label>';
      }).join('') + '</div>';
    },

    compute: function () {
      var c = this.cfg, d = this.data;

      if (c.kind === 'shoe') {
        var eu = Math.round((parseFloat(String(d.f).replace(',', '.')) + 1.5) * 1.5);
        if (d.foot2 === 'breit') eu += 1;
        var numeric = c.sizes.some(function (s) { return !isNaN(parseFloat(s)); });
        var pickS = pickClosest(eu, c.sizes, numeric);
        return pickS ? {
          label: pickS,
          headline: 'Ihre empfohlene Schuhgröße',
          text: 'Auf Basis einer Fußlänge von ' + String(d.f).replace('.', ',') + ' cm' +
                (d.foot2 === 'breit' ? ' und einem eher breiten Fuß' : '') + '.',
          alt: 'Zwischen zwei Größen? Bei Stiefeln und geschlossenen Schuhen nehmen Sie im Zweifel die größere Nummer — besonders, wenn Sie dickere Socken tragen.'
        } : null;
      }

      var idx = baseIndex(c.gender, parseFloat(d.h), parseFloat(d.w));
      if (d.build === 'kraeftig') idx += 0.6;
      if (d.build === 'schlank') idx -= 0.25;
      if (d.fit === 'weit') idx += 0.7;
      if (d.fit === 'eng') idx -= 0.4;
      if (c.kind === 'outer') idx += 0.25;
      if (c.kind === 'dress') idx += 0.1;

      var want = ORDER[clampIdx(idx)];
      var pick = pickClosest(want, c.sizes, false);
      if (!pick) {
        var numeric2 = c.sizes.some(function (s) { return !isNaN(parseFloat(s)); });
        if (numeric2) {
          var conf = (c.gender === 'h' ? 44 : 32) + clampIdx(idx) * 2;
          pick = pickClosest(conf, c.sizes, true);
        }
      }
      if (!pick) return null;

      var neighbour = '';
      var pi = ORDER.indexOf(normSize(pick));
      var frac = idx - Math.round(idx);
      if (Math.abs(frac) > 0.28 && pi > -1) {
        var alt = ORDER[clampIdx(pi + (frac > 0 ? 1 : -1))];
        var altAvail = pickClosest(alt, c.sizes, false);
        if (altAvail && normSize(altAvail) !== normSize(pick)) {
          neighbour = 'Sie liegen nah an <b>' + altAvail + '</b>. Mögen Sie es ' +
            (frac > 0 ? 'etwas lockerer, nehmen Sie diese Größe.' : 'körpernäher, nehmen Sie diese Größe.');
        }
      }

      return {
        label: pick,
        headline: 'Ihre empfohlene Größe',
        text: 'Berechnet aus ' + d.h + ' cm, ' + d.w + ' kg' +
              (d.build === 'kraeftig' ? ', kräftigere Statur' : d.build === 'schlank' ? ', schmale Statur' : '') +
              (d.fit === 'weit' ? ' und lockerem Sitz' : d.fit === 'eng' ? ' und figurbetontem Sitz' : '') + '.',
        alt: neighbour || 'Diese Empfehlung passt den meisten Kundinnen und Kunden mit Ihren Angaben. Sollte etwas nicht sitzen, haben Sie 90 Tage Zeit für die Rückgabe.'
      };
    },

    resultHtml: function () {
      this.result = this.compute();
      if (!this.result) {
        return '<div class="bmh-sa__result">' +
          '<p class="bmh-sa__resulttitle">Für dieses Produkt können wir keine Größe berechnen</p>' +
          '<p class="bmh-sa__resulttext">Schreiben Sie uns kurz — wir sehen für Sie in den Maßtabellen nach und antworten meist innerhalb weniger Stunden.</p>' +
          '<p class="bmh-sa__mail"><a href="mailto:info@bambergmodehaus.de?subject=Gr%C3%B6%C3%9Fenberatung">info@bambergmodehaus.de</a></p></div>';
      }
      var r = this.result;
      return '<div class="bmh-sa__result">' +
        '<span class="bmh-sa__badge">' + r.label + '</span>' +
        '<p class="bmh-sa__resulttitle">' + r.headline + '</p>' +
        '<p class="bmh-sa__resulttext">' + r.text + '</p>' +
        '<p class="bmh-sa__alt">' + r.alt + '</p>' +
        '<p class="bmh-sa__mail">Unsicher? Schreiben Sie uns an <a href="mailto:info@bambergmodehaus.de?subject=Gr%C3%B6%C3%9Fenberatung">info@bambergmodehaus.de</a> — wir beraten Sie persönlich.</p>' +
        '</div>';
    },

    validate: function () {
      var host = document.getElementById('bmhSizeAssistant');
      var name = this.steps()[this.step];
      var err = $('[data-sa-err]', host);
      if (name === 'body') {
        var h = parseFloat(($('#saH', host) || {}).value), w = parseFloat(($('#saW', host) || {}).value);
        if (!h || !w || h < 130 || h > 215 || w < 35 || w > 200) { if (err) err.classList.remove('bmh-hide'); return false; }
        this.data.h = h; this.data.w = w; return true;
      }
      if (name === 'foot') {
        var f = parseFloat(String((($('#saF', host) || {}).value) || '').replace(',', '.'));
        if (!f || f < 19 || f > 34) { if (err) err.classList.remove('bmh-hide'); return false; }
        this.data.f = f; return true;
      }
      var key = name === 'build' ? 'build' : name === 'fit' ? 'fit' : name === 'fitShoe' ? 'foot2' : null;
      if (key) {
        var sel = $('input[name="sa_' + key + '"]:checked', host);
        this.data[key] = sel ? sel.value : 'normal';
      }
      return true;
    },

    addToCart: function () {
      if (!this.result) return;
      var label = normSize(this.result.label);
      var target = $$('[data-bmh-size-value]').filter(function (el) {
        return normSize(el.getAttribute('data-bmh-size-value')) === label;
      })[0];
      this.close();
      if (target) {
        var input = target.tagName === 'INPUT' ? target : $('input', target);
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        else target.click();
      }
      setTimeout(function () {
        var btn = $('[data-bmh-atc]') || $('form[action*="/cart/add"] [type="submit"]');
        if (btn) btn.click();
      }, 260);
    }
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bmh-size-open]')) { e.preventDefault(); SA.open(); return; }
    if (e.target.closest('[data-sa-close]') || e.target.closest('.bmh-modal__veil') || e.target.closest('.bmh-modal__x')) {
      if (e.target.closest('#bmhSizeAssistant')) { e.preventDefault(); SA.close(); }
      return;
    }
    if (e.target.closest('[data-sa-next]')) {
      e.preventDefault();
      if (SA.validate()) { SA.step = Math.min(SA.step + 1, SA.steps().length - 1); SA.render(); }
      return;
    }
    if (e.target.closest('[data-sa-back]')) { e.preventDefault(); SA.step = Math.max(0, SA.step - 1); SA.render(); return; }
    if (e.target.closest('[data-sa-add]')) { e.preventDefault(); SA.addToCart(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') SA.close();
  });

  /* ============================================================
     4) FARBKACHELN -> Bildwechsel + Label
     ============================================================ */
  document.addEventListener('change', function (e) {
    var sw = e.target.closest('.bmh-swatch');
    if (!sw) return;
    var input = e.target;
    var label = $('[data-bmh-swatch-current]');
    if (label) label.textContent = input.getAttribute('data-value') || '';
  });

  /* ============================================================
     Start
     ============================================================ */
  function init() {
    mountProgress();
    // Schublade wird oft nachtraeglich gerendert
    var host = $('#CartDrawer') || $('.drawer--cart');
    if (host && window.MutationObserver) {
      new MutationObserver(debounce(function () { mountProgress(); }, 250)).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
